import React from 'react';
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { InfoArrayHome1, InfoArrayHome2, InfoArrayHome3 } from './InfoComponents';

interface ComparisonItem {
  label: string;
  system: number;
  aici: number;
  infoType?: number;
  img?: React.ReactNode;
}

interface ComparisonTableProps {
  dataList: ComparisonItem[];
  leftColumnTitle: string;
  rightColumnTitle: string;
  bottomRowData: {
    left: string;
    middle: string;
    right: string;
  };
}

const ComparisonTable: React.FC<ComparisonTableProps> = ({
  dataList,
  leftColumnTitle,
  rightColumnTitle,
  bottomRowData
}) => {
  const getCellContent = (value: number) => {
    if (value === 1) {
      return <CheckCircleIcon />;
    } else if (value === 0) {
      return <CancelSharpIcon />;
    } else if (value === 2) {
      return "21,1% ou 10,55% avec l'ACRE";
    } else if (value === 3) {
      return "45%";
    }
    return "";
  };

  const getCellClassName = (value: number) => {
    if (value === 1) {
      return "border-b-2 border-l-2 border-r-2 py-4 md:px-4 px-1 text-[#0074E4] text-center";
    } else if (value === 0) {
      return "border-b-2 border-l-2 border-r-2 py-4 md:px-4 px-1 text-[#FF724F] text-center";
    } else {
      return "border-b-2 border-l-2 border-r-2 py-4 md:px-4 px-1 text-normal font-bold text-center";
    }
  };

  return (
    <div className="pb-10 text-normal md:text-lg">
      <div className="md:px-10 px-3">
        <div className="w-full mx-auto border-2 rounded-t-3xl shadow-md">
          <table className="w-full">
            <thead>
              <tr className="font-bold">
                <th className="border-b-2 py-4 md:px-4 px-1 text-left w-1/3">
                  {/* Colonne des labels */}
                </th>
                <th className="border-b-2 border-l-2 border-r-2 py-4 md:px-4 px-1 w-1/3">
                  {leftColumnTitle}
                </th>
                <th className="border-b-2 py-4 md:px-4 px-1 w-1/3 bg-[#EBF7FF] rounded-tr-3xl">
                  {rightColumnTitle}
                </th>
              </tr>
            </thead>
                              <tbody>
                    {dataList.map((item, index) => (
                      <tr key={index}>
                        <td className="border-b-2 flex gap-x-2 py-4 md:px-4 px-1">
                          {item.label} {item.img}
                          {item.infoType === 1 && <InfoArrayHome1 />}
                          {item.infoType === 2 && <InfoArrayHome2 />}
                          {item.infoType === 3 && <InfoArrayHome3 />}
                        </td>
                  <td className={getCellClassName(item.system)}>
                    {getCellContent(item.system)}
                  </td>
                  <td className={getCellClassName(item.aici)}>
                    {getCellContent(item.aici)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex border-2 md:px-10 rounded-3xl -mt-3 z-50 bg-gradient-to-l from-[#EBF7FF] to-white shadow-lg font-bold">
        <div className="py-8 md:px-4 px-1 w-1/3 bg-white">
          {bottomRowData.left}
        </div>
        <div className="border-l-2 border-r-2 py-8 md:px-4 px-1 w-1/3 bg-white">
          {bottomRowData.middle}
        </div>
        <div className="py-8 md:px-4 px-1 w-1/3 bg-[#EBF7FF] rounded-tr-3xl">
          {bottomRowData.right}
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable; 